export default __webpack_public_path__ + "static/media/TVSsportFamilia.af67741e.webp";